import { Api } from "./Api.class";
const endpoint = "tags";
const tagsAPI = new Api(endpoint);
export default tagsAPI;
